import http from "@/services/http";
import { featureFlags } from "@/config/env";
import { mockManager } from "@/services/mock";

// 内容引用分析请求参数
export interface ContentCiteParams {
  brandId?: string;
  categoryId: string;
  days?: number;
  modelId?: string;
}

// 内容引用分析数据项
export interface ContentCiteItem {
  title: string;
  site_name: string;
  rate: number;
}

// 内容引用分析响应
export interface ContentCiteResponse {
  code: number;
  message: string;
  data: ContentCiteItem[];
}

/**
 * 内容引用分析 API
 */
export const contentCiteApi = {
  /**
   * 获取内容引用分析数据
   */
  async getContentCite(params: ContentCiteParams): Promise<ContentCiteItem[]> {
    if (featureFlags.enableMock) {
      return await mockManager.getContentCite(params);
    }

    try {
      const response = await http.get<ContentCiteResponse>(
        "data/cite/article",
        { params }
      );
      return response.data.data;
    } catch (err) {
      // 网络或接口错误时，返回空数据
      return [];
    }
  },
};

export default contentCiteApi;
